(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SchemaViewer", [], factory);
	else if(typeof exports === 'object')
		exports["SchemaViewer"] = factory();
	else
		root["SchemaViewer"] = factory();
})(window, function() {
return 